import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { tokens } from '@fluentui/react-components';
import { PolarChart } from '@fluentui/react-charting';
import { WidgetContainer } from '../WidgetContainer';
import { ChartThemeProvider } from '../ChartThemeProvider';
import { useSpaceTypeSatisfactionChartStyles } from './SpaceTypeSatisfactionChart.styles';
import type { SpaceTypeSatisfaction } from '@/types/reports';

export interface SpaceTypeSatisfactionChartProps {
  data: SpaceTypeSatisfaction[];
  titleKey: string;
}

export function SpaceTypeSatisfactionChart({ data, titleKey }: SpaceTypeSatisfactionChartProps) {
  const styles = useSpaceTypeSatisfactionChartStyles();
  const { t } = useTranslation('reports');

  const chartData = useMemo(
    () => [
      {
        type: 'areapolar' as const,
        legend: t('widgets.csatPolarLegend'),
        data: data.map((d) => ({
          theta: d.spaceType,
          r: d.csatScore,
          callout: `${d.spaceType}: ${d.csatScore.toFixed(1)}`,
        })),
        color: tokens.colorBrandForeground1,
      },
    ],
    [data, t]
  );

  return (
    <WidgetContainer title={t(titleKey)}>
      <div className={styles.root} role="figure" aria-label={t(titleKey)}>
        <ChartThemeProvider>
          <PolarChart
            data={chartData}
            chartTitle={t(titleKey)}
            shape="polygon"
            height={300}
            width={350}
            hideLegend
            hideTooltip={false}
          />
        </ChartThemeProvider>
      </div>
    </WidgetContainer>
  );
}
